import { connect } from "react-redux";

import MyPlan from "./MyPlan";
import {
  getSubscriptionPlan,
  pauseSubscription,
  upgradePlan,
  submitSubscriptionFeedback,
  createBillingCheckout,
  applyBillingPlanChange,
  openBillingManagement,
  getBillingPlans,
} from "./subscriptionActions";
const mapStateToProps = (state) => ({
  auth: state.auth,
  myPlan: state.subscription.myPlan,
  billingManagementLoading: Boolean(state.subscription.billingManagementLoading),
  billingPlanChangeLoading: Boolean(state.subscription.billingMutationLoading),
  billingMutationError: state.subscription.billingMutationError || null,
  billingPlans: state.subscription.billingPlans,
  billingPlansLoading: Boolean(state.subscription.billingPlansLoading),
  billingPlansError: state.subscription.billingPlansError || null,
  isLoading:
    state.subscription.isLoading ||
    state.subscription.billingCheckoutLoading ||
    state.subscription.billingManagementLoading ||
    state.subscription.billingMutationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscriptionPlan: (data) => dispatch(getSubscriptionPlan(data)),
  upgradePlan: (data) => dispatch(upgradePlan(data)),
  cancelPlan: () => dispatch({ type: "CANCEL_PLAN" }),
  manageSubscription: (data) => dispatch(pauseSubscription(data)),
  submitFeedback: (data) => dispatch(submitSubscriptionFeedback(data)),
  createBillingCheckout: (data) => dispatch(createBillingCheckout(data)),
  applyBillingPlanChange: (data) => dispatch(applyBillingPlanChange(data)),
  openBillingManagement: (data) => dispatch(openBillingManagement(data)),
  getBillingPlans: () => dispatch(getBillingPlans()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPlan);
